import debounce from 'lodash/debounce';
import mapValues from 'lodash/mapValues';
import isPlainObject from 'lodash/isPlainObject';

export const createDebouncedAction = (actionCreator, delay = 300, options = {}) => {
  let lastArgs;

  const thunk = (dispatch) => {
    dispatch(actionCreator(...lastArgs));
  }

  const debounced = debounce(thunk, delay, options);

  const result = (...args) => {
    lastArgs = args;

    return debounced;
  };

  result.flush = () => debounced.flush();
  result.cancel = () => debounced.cancel();

  return result;
};

export const mergeInPersistent = (init, persistent = {}) =>
  mapValues(init, (initValue, key) => {
    if (isPlainObject(initValue) && Object.keys(initValue).length) {
      return mergeInPersistent(initValue, persistent[key]);
    }

    return (persistent[key] === null || typeof persistent[key] === 'undefined') ?
      initValue : persistent[key];
  });